






























import Vue from "vue";
export default Vue.extend({
  name: "Intro",
  props: {
    next: { type: Function, default: () => null },
    close: { type: Function, default: () => null },
  },
});
